const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev',
  BASE_IMAGE: 'https://restaurant-api.dicoding.dev/images/medium/',
  CACHE_NAME: 'MariMakan-V1',
  DATABASE_NAME: 'Mari-Makan-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
